/* eslint-disable react/jsx-curly-newline */
import { Breadcrumb } from 'components/Breadcrumb';
import { useState, useEffect } from 'react';
import { CgArrowRight } from 'react-icons/cg';
import { MdCheck } from 'react-icons/md';

import { useParams } from 'react-router-dom';
import { useHistoryWithHost } from 'routes/useHistoryWithHost';
import {
  Modal,
  Button,
  ModalCloseButton,
  ModalContent,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Radio,
  RadioGroup,
} from '@grupoboticario/flora-react';
import { deleteFile } from 'services/openClaimService';
import UploadInput, { FilesCallback } from 'components/UploadInput';
import { Download } from 'components/Download';
import { useDispatch, useSelector } from 'react-redux';
import {
  getClaimByIdAction,
  getStepsByIdAction,
  getStatusActionsAction,
} from 'store/modules/claims/actions';
import { ApplicationState } from 'store/store.inteface';
import { sendFile } from 'utils/sendFile';
import { BROKER_ACTIONS } from 'utils/statusEnum';
import {
  Container,
  Content,
  Title,
  Card,
  Label,
  ModalText,
  ModalTitle,
  ButtonWrapper,
  CircleStep,
  CardDeclarationRadio,
  CardDeclarationRadioText,
  TextArea,
  NoUpload,
} from './styles';

export function LossCalculation() {
  const initialState: any = {
    declarationRadio: null,
    motive: '',
  };
  const dispatch = useDispatch();
  const { statusActions } = useSelector(
    (state: ApplicationState) => state.claims,
  );
  const stepClaimStatus = useSelector(
    (state: ApplicationState) => state.claims.stepsClaimStatus,
  );
  const { claimById } = useSelector((state: ApplicationState) => state.claims);
  const { stores, cpId } = useSelector(
    (state: ApplicationState) => state.storesContext,
  );

  const { id } = useParams();
  const history = useHistoryWithHost();
  const [dropFiles, setDropFiles] = useState([]);
  const [files, setFiles] = useState<FilesCallback[]>([]);
  const [stateUpload, setStateUpload] = useState(initialState);
  const [modalSair, setModalSair] = useState(false);
  const [modalEnviar, setModalEnviar] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isPartial, setIsPartial] = useState(false);
  const [loadingData, setLoadingData] = useState(false);

  const preventEvent = (e: any) => {
    e.preventDefault();
  };

  const fileDrop = (e: any) => {
    e.preventDefault();
    const dropedFiles = e.dataTransfer.files;
    if (dropedFiles?.length) {
      setDropFiles(dropedFiles);
    }
  };

  useEffect(() => {
    if (
      ((stateUpload.declarationRadio === 'no' &&
        stateUpload.motive &&
        files.length) ||
        stateUpload.declarationRadio === 'yes') &&
      !loading
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [files, stateUpload, loading]);

  const onClickRadio = (e: any) => {
    if (e.target.value === 'yes') {
      setStateUpload((prevState: any) => ({
        ...prevState,
        declarationRadio: e.target.value,
        motive: '',
      }));
    } else {
      setStateUpload((prevState: any) => ({
        ...prevState,
        declarationRadio: e.target.value,
      }));
    }
  };

  useEffect(() => {
    if (stores.length > 0) {
      dispatch(getClaimByIdAction(id));
      dispatch(getStatusActionsAction(id));
      dispatch(getStepsByIdAction(id));
    }
  }, [dispatch, id, stores]);

  useEffect(() => {
    const partialPaid = stepClaimStatus.find(
      obj => obj.statusBroker === BROKER_ACTIONS.PaidProcessPP,
    );

    if (partialPaid) {
      setIsPartial(true);
    } else {
      setIsPartial(false);
    }
  }, [isPartial, stepClaimStatus]);

  const sendFiles = async () => {
    setLoading(true);
    try {
      await sendFile(
        id,
        files,
        isPartial ? 'lossCalculationPP' : 'lossCalculation',
        cpId,
        claimById.franchise.code,
        stateUpload.motive,
      );
      setModalEnviar(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoadingData(false);
    if (!statusActions.documentAction) {
      setLoadingData(true);
    }
  }, [statusActions]);

  return (
    <Container>
      <Breadcrumb color="light" claimNumber={statusActions.number} />
      <Content>
        <Title>
          <span>Apuração de Prejuízos</span>
        </Title>
        <Label>
          <p>
            <CircleStep>1</CircleStep>
            Você recebeu uma planilha de aceite, baixe e analise com muita
            atenção.
          </p>
          <p>
            <CircleStep>2</CircleStep>Após analisada será necessário que escolha
            a opção desejada.
          </p>
          <p>
            <CircleStep>3</CircleStep>Caso necessite enviar algum documento para
            conferência
          </p>
        </Label>
        <Card>
          <div className="card-text">
            <Download
              loading={loadingData}
              uri={statusActions?.fileAction?.url}
              filename={`Apuração de Prejuízos - Sinistro #${statusActions.number}`}
              // eslint-disable-next-line prettier/prettier
              header={
                <span className="card-title">
                  <CircleStep>1</CircleStep> BAIXAR PLANILHA
                </span>
                // eslint-disable-next-line prettier/prettier
              }
            />
          </div>
          <div className="card-text">
            <span className="card-title">
              <CircleStep>2</CircleStep> ACEITE
            </span>
            <RadioGroup value={stateUpload?.declarationRadio}>
              <CardDeclarationRadio>
                <div className="radioBlock">
                  <Radio
                    id="yes"
                    value="yes"
                    size="small"
                    onClick={onClickRadio}
                  />
                  <CardDeclarationRadioText as="label" htmlFor="yes">
                    Concordo com os termos e valores apresentados.
                  </CardDeclarationRadioText>
                </div>
                <div className="radioBlock">
                  <Radio
                    id="no"
                    value="no"
                    size="small"
                    onClick={onClickRadio}
                  />
                  <CardDeclarationRadioText as="label" htmlFor="no">
                    Não concordo com os termos e valores apresentados.
                  </CardDeclarationRadioText>
                </div>
              </CardDeclarationRadio>
            </RadioGroup>
            <TextArea
              className={
                stateUpload.declarationRadio === 'no' ? '' : 'disabled'
              }
            >
              <span className="motivo">Motivo:</span>
              <textarea
                value={stateUpload.motive}
                onChange={e =>
                  setStateUpload((prevState: any) => ({
                    ...prevState,
                    motive: e.target.value,
                  }))
                }
                disabled={stateUpload.declarationRadio !== 'no'}
              />
            </TextArea>
          </div>
          <div
            onDragOver={preventEvent}
            onDragEnter={preventEvent}
            onDragLeave={preventEvent}
            onDrop={fileDrop}
            className="card-text"
          >
            <span className="card-title">
              <CircleStep>3</CircleStep> Outros
            </span>
            <p>Adicione aqui todos os documentos</p>
            {stateUpload.declarationRadio === 'no' && (
              <UploadInput
                idDoc="Apuracao de Prejuizos"
                setState={setStateUpload}
                required
                dropFiles={dropFiles}
                hasLoadingFiles={false}
                callbackFunc={cFiles => setFiles(cFiles)}
                deleteFile={deleteFile}
              />
            )}
            {stateUpload.declarationRadio === 'yes' && (
              <NoUpload>
                <MdCheck />
                <p>Não será necessário o envio de qualquer documento!</p>
              </NoUpload>
            )}
          </div>
        </Card>
        <ButtonWrapper>
          <Button
            className="sair"
            size="small"
            onClick={() => setModalSair(true)}
          >
            Sair
          </Button>
          <Button
            className="enviar"
            size="small"
            styleSemantic="success"
            onClick={sendFiles}
            disabled={disabled}
          >
            Enviar
            <CgArrowRight size={17} className={disabled ? 'disabled' : ''} />
          </Button>
        </ButtonWrapper>

        <Modal open={modalSair} onOpenChange={setModalSair}>
          <ModalContent>
            <ModalCloseButton />
            <ModalHeader />
            <ModalBody>
              <ModalText>Deseja mesmo sair?</ModalText>
            </ModalBody>
            <ModalFooter>
              <Button onClick={() => history.goBack()}>Sim</Button>
              <Button
                styleSemantic="warning"
                onClick={() => setModalSair(false)}
              >
                Não
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Modal open={modalEnviar} onOpenChange={() => history.goBack()}>
          <ModalContent size="small">
            <ModalCloseButton />
            <ModalHeader />
            <ModalBody>
              <ModalText>
                <MdCheck />
                {stateUpload.declarationRadio === 'no' && (
                  <ModalTitle>Dados enviados para análise.</ModalTitle>
                )}
                Você receberá avisos no status deste processo, fique de olho!
              </ModalText>
            </ModalBody>
            <ModalFooter>
              <Button styleSemantic="success" onClick={() => history.goBack()}>
                OK
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Content>
    </Container>
  );
}
